var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"MetricIndicator"},[_c('div',{style:(("width: " + (_vm.value * 100) + "%; background-color: " + (_vm.getColor(_vm.value))))})])}
var staticRenderFns = []

export { render, staticRenderFns }